import React, { useEffect, useRef } from 'react';
import { z } from 'zod';
import { ViewerPropertiesComplete } from '../model';
import { useLocalStorageBackedState } from './common/3d/useLocalStoreBackedState';
import { useResource } from './common/useResource';
import { ProviderResult } from './common/image';
export const MediaVideo: React.FC<ViewerPropertiesComplete> = ({
  src,
  onMetadataAvailable,
  autoPlay,
  muted,
  imageMetadataProvider,
}) => {
  const { data } = useResource<ProviderResult>(imageMetadataProvider?.loadURL);
  const [volume, setVolume] = useLocalStorageBackedState(0.25, z.number(), 'video volume');
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (data !== undefined && data.metadata.resolution !== undefined) {
      onMetadataAvailable({
        width: data.metadata.resolution[0],
        height: data.metadata.resolution[1],
        duration: parseFloat(data.metadata.duration ?? '0'),
      });
    }
  }, [data, onMetadataAvailable]);

  useEffect(() => {
    function setvolume(videoElement: HTMLVideoElement) {
      videoElement.volume = volume;
    }
    function test() {
      if (videoRef.current) {
        setvolume(videoRef.current);
      } else setTimeout(test, 0.01);
    }
    test();
  }, [volume]);

  return (
    <video
      ref={videoRef}
      className="ch-file-viewer__video gen-file-viewer__container"
      src={src}
      onVolumeChange={(e) => {
        setVolume((e.target as HTMLVideoElement).volume);
      }}
      crossOrigin="use-credentials"
      controls
      autoPlay={autoPlay}
      muted={muted}
    />
  );
};
